import { REDESIGN_CSAT_SURVEY_ID } from 'calling-internal-common/constants/CsatSurveyIds';
import { isTransferAccepted } from 'calling-cross-tab-library/appData/operators/transferInformationOperators';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { getTransferInformation } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { useEffect } from 'react';
import enviro from 'enviro';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import { capabilities } from 'navigation-components/capabilities';
export const useOpenTransferCsat = () => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const transferInformation = getTransferInformation(widgetDetails);
  const transferAccepted = isTransferAccepted(transferInformation);
  const openSurvey = useInvokeCapability(capabilities.TOGGLE_CSAT_SURVEY_CAP);
  useEffect(() => {
    if (enviro.isProd() && transferAccepted) {
      openSurvey({
        surveyId: REDESIGN_CSAT_SURVEY_ID
      });
    }
  }, [openSurvey, transferAccepted]);
};